module.exports = __webpack_public_path__ + "static/media/smartday.76a2d3a1.png";